import React from "react"

import { AppAcrissGroupsAutocomplete } from "@components"
import { acrissGroups } from "@signals"


export default function AcrissGroupsAutocomplete({ ...props }) {
	return <AppAcrissGroupsAutocomplete
		value={acrissGroups.value || []}
		onChange={e => acrissGroups.value = e.target.value}
		{...props}
	/>
}
